import React, {useEffect, useState} from 'react';
import * as EnergyActions from '../../../actions/energyActions';
import { connect } from 'react-redux';
import ExecutiveSummaryTile from '../../../components/ExecutiveSummaryTile';
import NoSelectedSensorsScreen from '../../../components/NoSelectedSensorsScreen';
import { isEmpty } from 'lodash';

import {
    Chart,
    ChartSeries,
    ChartSeriesItem,
    ChartLegend,
} from '@progress/kendo-react-charts';

import * as classes from './ExecutiveSummaryScoreGuage.module.css';

const ExecutiveSummarEnergyUse = ({
    bobLoading,
    extendedColumns,
    siteEnergyEquipmentGroup,
    ...props
}) => {
    const [series, setSeries] = useState([]);
    useEffect(() => {
        setSeries(siteEnergyEquipmentGroup);
    }, [siteEnergyEquipmentGroup]);

    const labelContent = props => {
        return `${props.dataItem.energyPercentage} %`;
    };

    const colors = [
        '#1337ff',
        '#ff3a2c',
        '#26dc2e',
        '#fdbf00',
        '#007eff',
        '#28b4c8',
        '#aa46be',
        '#ff10f8',
        '#ff5c69',
        '#d94c92',
        '#cc0000',
        '#a5502b',
        '#5c2aba'
    ];

    return (

        <ExecutiveSummaryTile isLoading={bobLoading.includes('FetchSiteEnergyData')}>

            {bobLoading.includes('FetchSiteEnergyGroupData') ?
                <div className={classes.Loader}>
                    <img src="/assets/images/BobLoaderLarge.gif" alt="loader" />
                </div>
                :
                <div>
                    {isEmpty(siteEnergyEquipmentGroup) ?
                        <NoSelectedSensorsScreen
                            style={{
                                width: '100%'
                            }}
                            message="Please select a site from the dropdown list above to load the Energy data."
                        />
                        : <React.Fragment>
                            <Chart seriesColors={colors}>
                                <ChartLegend visible="true" position="bottom" />
                                <ChartSeries>
                          
                                    <ChartSeriesItem
                                        data={series}
                                        field="energyPercentage"
                                        categoryField="equipmentType"
                                        type="donut"
                                        labels={{
                                            visible:    true,
                                            content:    labelContent,
                                            background: 'none',
                                            align:      'circle',
                                            position:   'outsideEnd'
                                        }}
                                    />
                          
                                </ChartSeries>
                            </Chart>
                        </React.Fragment>
                    }
                </div>
            }
        </ExecutiveSummaryTile>


    );
};

const mapStateToProps = state => {
    return {
        bobLoading:               state.bob.bobLoading,
        siteEnergyEquipmentGroup: state.energy.siteEnergyEquipmentGroup
    };
};

const mapDispatchToProps = ({
    ...EnergyActions
});


export default connect(mapStateToProps, mapDispatchToProps)(ExecutiveSummarEnergyUse);
